module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAiCAYAAACuoaIwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADLSURBVHgB7dYtDsIwGMbxp6XjIzOTBBKyI3AeUDsIYYgdgBOgwMINwOLQ6ClCMJhlXy8zGMLWZWvB9J/UPclP1LxsHIRTAEcCHDQoTyI8rmc/3s1Xsi0vkH1T6B0D+d3Zdinb8eK5UFAdkENhMlApJgOVY1WgFqwM1IZ9A1tj3OpD2E4tkI2CkNAyylLEzzuyOCrddAa2J6Ag1hHoOcPqUU6u1j/7zGAGM5jBDGYwgxnsLxgxnPCDUtBFEEs85NamuCZd6Iqwvi0mhxe66UHvNQ8dGwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/form-data/file-dropbox.png
// module id = iHlV
// module chunks = 46